module.exports = {"231283100":"海伦镇","231283101":"海北镇","231283102":"伦河镇","231283103":"共合镇","231283104":"海兴镇","231283105":"祥富镇","231283106":"东风镇","231283107":"百祥镇","231283202":"前进乡","231283203":"向荣乡","231283204":"长发乡","231283205":"东林乡","231283208":"海南乡","231283209":"共荣乡","231283210":"乐业乡","231283211":"福民乡","231283212":"丰山乡","231283213":"永富乡","231283216":"联发乡","231283217":"永和乡","231283218":"爱民乡","231283220":"扎音河乡","231283221":"双录乡","231283400":"林场公司","231283401":"东方红水库地区","231283500":"海伦农场","231283501":"红光农场","231283581":"海伦二粮种场","231283582":"海伦种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231283.json
// module id = 741
// module chunks = 0